module.exports = __webpack_public_path__ + "img/text-k-gradient-large.b25a2a2a.svg";